import React, { memo } from "react";
import { Project } from "../../../../infrastructure/types/project";
import SingleProject from "../singleProject";

type ProjectsListProps = {
  projects: Project[];
};
const ProjectsList = ({ projects }: ProjectsListProps) => {
  return (
    <div className="projects-list" data-scroll data-scroll-repeat>
      {projects.map((project) => (
        <SingleProject project={project} key={project._id} />
      ))}
    </div>
  );
};

export default memo(
  ProjectsList,
  (prev, next) => prev.projects.length === next.projects.length
);
